
import { Card, CardContent } from "@/components/ui/card";
import { Map } from "@/components/Map";

interface Service {
  id: string;
  professional_id: string;
  service_name: string;
  description?: string;
  duration: number;
  price?: number;
  address?: string;
  phone?: string;
  email?: string;
  photo_url?: string;
  country?: string;
  profiles?: {
    full_name?: string;
    practice_address?: string;
  };
}

interface Product {
  id: string;
  title: string;
  description: string;
  price: number;
  address?: string;
  phone?: string;
  photo_url?: string;
  professional_id: string;
  profiles?: {
    full_name?: string;
    practice_address?: string;
  };
}

interface ServiceMapProps {
  services: Service[];
  products?: Product[];
}

export const ServiceMap = ({ services, products = [] }: ServiceMapProps) => {
  // Combine services and products into a single array for the map
  const locations = [...services, ...products];

  return (
    <Card>
      <CardContent className="p-0">
        <Map services={locations} />
      </CardContent>
    </Card>
  );
};
